// https://www.gatsbyjs.com/docs/global-css/
import 'normalize.css';
import '@vtblife/uikit/dist/css/grid.css';
import '@vtblife/uikit/dist/css/global.css';
import '@vtblife/uikit-theme';
import svg from '@vtblife/uikit-icons/dist/svg-inline';

import './gatsby-browser-global-css.css';
export { wrapRootElement } from './src/wrap-root';
export { wrapPageElement } from './src/wrap-page';

document.body.appendChild(svg);

const initialState = window.__INITIAL_STATE__;

function replaceHistory() {
    const originalPath = initialState?.growthBookData?.originalPath;
    if (originalPath) {
        const restoredUrl = originalPath + window.location.search + window.location.hash;
        window.history.replaceState('page', window.document.title, restoredUrl);
    }
}

if (initialState?.growthBookData?.pageContentReplaced && initialState?.growthBookData?.originalPath) {
    if (document.readyState === 'complete') {
        replaceHistory();
    } else {
        window.addEventListener('load', replaceHistory);
    }
}
